// extracted by mini-css-extract-plugin
export default {"labelText":"AddPromotionLine_labelText__jdnks","btnAdd":"AddPromotionLine_btnAdd__9Pvbj"};